<template>
  <div class="signup">
    <div class="title"> {{ $t('title')}}</div>
    <div class="signup-form">
      <md-field>
        <div class="form-label">{{$t('mobileNumber')}}</div>
        <md-input-item
          name="mobileNumber"
          type="digit"
          v-model="form.mobile"
          class="bordered mobile-input"
          v-validate="'required|betweenLength:8,13'"
          :error="errors.first('mobileNumber')"
          placeholder="">
          <div slot="left" class="mobile-prefix" @click="showSelector">
            <span class="prefix-text">{{form.mobileCountry}}</span>
            <md-icon name="arrow-down" size="sm"></md-icon>
          </div>
        </md-input-item>
        <md-selector
          class="mobile-prefix-selector"
          v-model="selectorVisible"
          :data="mobilePrefixList"
          default-value="+62"
          cancel-text="cancel"
          title="Mobile Prefix"
          max-height="400px"
          @choose="onSelectorChoose($event)"
        ></md-selector>
        <div class="form-label">{{$t('verificationCode')}}</div>
        <md-input-item
          name="verificationCode"
          class="bordered verification-code"
          v-model="form.verificationCode"
          v-validate="'required|digits:6'"
          :error="errors.first('verificationCode')"
        >
          <md-button
            type="blue"
            :inactive="!form.mobile.length || sendInterval !== null"
            @click="getVerifyCode('additional')" slot="right"
          >
            {{ sendButtonText }}
          </md-button>
        </md-input-item>
      </md-field>
      <div class="button-submit">
        <md-button type="primary" round @click="submit">
          {{ $t('submit') }}
        </md-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Field, FieldItem, Icon, InputItem, Selector, Button, Tabs, Agree } from 'mand-mobile'
import mobileMixins from '@/mixins/mobile'

export default {
  i18n: {
    messages: {
      en: {
        title: 'For the security of your account, please bind your phone number immediately',
        mobileNumber: 'Verify via phone',
        send: 'Send',
        resend: 'Resend',
        verificationCode: 'Input verification code',
        verificationCodeSent: 'The verification code has been sent. Please Kindly check.',
        submit: 'Submit',
      },
      id: {
        title: 'Demi keamanan akun Anda, silahkan isi nomor handphone Anda segera',
        mobileNumber: 'Verifikasi melalui ponsel',
        send: 'Daftar',
        resend: 'Daftar ulang',
        verificationCode: 'Masukkan kode verifikasi',
        verificationCodeSent: 'Kode verifikasi telah dikirim. Silakan periksa.',
        submit: 'Daftar',
      },
    },
  },
  components: {
    [Field.name]: Field,
    [FieldItem.name]: FieldItem,
    [Icon.name]: Icon,
    [InputItem.name]: InputItem,
    [Selector.name]: Selector,
    [Button.name]: Button,
    [Tabs.name]: Tabs,
    [Agree.name]: Agree,
  },
  mixins: [mobileMixins],
  methods: {
    async submit() {
      const valid = await this.$validator.validateAll()
      if (!valid) {
        return
      }
      const fullNumber = `${this.form.mobileCountry}${this.form.mobile}`
      const payload = {
        mobileNumber: fullNumber,
        code: this.form.verificationCode,
      }
      try {
        this.$toast.loading('loading...')
        await this.$http.post('/investor/edit-mobile', payload)
        await this.$store.dispatch('reloadInvestor')
        this.$router.push({ name: 'Home' })
      } catch (error) {
        console.error(error)
      } finally {
        this.$toast.hide()
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.signup {
  margin: 0 auto;
  padding: 30px 24px;
  min-height: calc(100vh - 64px);
  background-color: #fff;
}

.title {
  font-size: 18px;
  line-height: 1.25em;
  margin-bottom: 6px;
  font-weight: bold;
}

.subtitle {
  font-size: 18px;
  color: #555;
  margin-bottom: 20px;
  line-height: 12px;
}

.form-label {
  font-size: 14px;
  margin: 20px 0 8px 0;
}

.mobile-prefix /deep/ {
  .md-field-item-inner {
    padding: 0;
  }
  &.has-arrow .md-field-item-content {
    padding: 0 5px 0 5px;
  }
}

.agreement {
  margin-top: 8px;
  font-size: 12px;
  line-height: 1.25em;
}

.error-tip {
  color: red;
  margin-top: 10px;
}

.button-submit /deep/ {
  margin-top: 30px;
}

.login-tip {
  margin: 10px 0 0 15px;
  display: flex;
  justify-content: center;
  font-size: 13px;
  .login-link {
    margin-left: 10px;
  }
}

.signup /deep/ {
  .md-button.blue {
    background-color: #5C9DE7;
    color: #fff;
    font-size: 14px;
  }
  .md-input-item {
    padding: 0;
  }
  .md-button.link.large {
    font-size: 13px;
    font-weight: 500;
    color: #5d9ce7;
    width: unset;
  }

}
</style>
